import { render, staticRenderFns } from "./CurrencySwitcher.vue?vue&type=template&id=cf3b0a12&scoped=true&"
import script from "./CurrencySwitcher.vue?vue&type=script&lang=js&"
export * from "./CurrencySwitcher.vue?vue&type=script&lang=js&"
import style0 from "./CurrencySwitcher.vue?vue&type=style&index=0&id=cf3b0a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3b0a12",
  null
  
)

export default component.exports